import React from 'react';

export default function Index() {
  return <></>;
}

export { Index };
